<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';

  // Tiny render-as-side-effect helper. Use inside route guards to push the
  // user somewhere else without rendering anything (the parent guard owns
  // the transient "redirecting…" UI if it wants any).

  interface Props {
    to: string;
    /** True replaces the current history entry instead of pushing. */
    replace?: boolean;
  }

  let { to, replace = false }: Props = $props();

  onMount(() => {
    navigate(to, { replace });
  });
</script>
